
export const LOG_TYPE = {
  backend: 'backend',
  microservice: 'microservice',
  alerting: 'alerting',
  exporter: 'exporter',
  reporter: 'reporter',
  mailer: 'mailer',
  'alias-import': 'alias-import',
  "health-monitor": "health-monitor",
} as const;